export const NotificationTypes = {
  PathwayInvitation: 'pathway_invitation',
  PathwayInvitationActioned: 'pathway_invitation_actioned',
  TopicSuggestion: 'topic_suggestion',
  TopicSuggestionActioned: 'topic_suggestion_actioned',
  CircleInvitation: 'circle_invitation',
  CircleGoalMilestoneCreated: 'circle_goal_milestone_created',
  CirclePulseSent: 'circle_pulse_sent',
  CirclePulseResponded: 'circle_pulse_responded',
  CircleMilestoneCompleted: 'circle_milestone_completed'
} as const;
